export const SHIPPING_DEMO = {
  zones: [
    { id: 'sz_01', name: 'Bogotá D.C.',   countries: ['CO'], states: ['11'],     baseRate: 0,      freeAbove: 150000 },
    { id: 'sz_02', name: 'Resto del país', countries: ['CO'], states: ['*'],     baseRate: 18000,  freeAbove: 250000 },
    { id: 'sz_03', name: 'Internacional',  countries: ['*'], states: [],         baseRate: 89000,  freeAbove: null },
  ],
  carriers: [
    { id: 'crr_01', name: 'Coordinadora', enabled: true,  apiConnected: false },
    { id: 'crr_02', name: 'Servientrega', enabled: false, apiConnected: false },
    { id: 'crr_03', name: 'Interrapidísimo', enabled: true, apiConnected: false },
  ],
  recentShipments: [
    { id: 'shp_01', orderNumber: 'ORD-MOXCA06Y-LYLU', carrier: 'Coordinadora', tracking: 'COORDI-998877', status: 'in_transit',  shippedAt: '2026-05-08T09:00:00.000Z' },
    { id: 'shp_02', orderNumber: 'ORD-MOX9XL2P-FFFF', carrier: 'Coordinadora', tracking: 'COORDI-998801', status: 'delivered',   shippedAt: '2026-05-06T10:00:00.000Z' },
  ],
}
